import { useState } from 'react';
import { X, ZoomIn } from 'lucide-react';
import { PublishedAsset } from '../../../services/participant.service';

interface Props {
  assets: PublishedAsset[];
}

export function AssetsTab({ assets }: Props) {
  const [lightbox, setLightbox] = useState<PublishedAsset | null>(null);

  if (assets.length === 0) {
    return (
      <div className="flex-1 flex items-center justify-center p-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-white/5 rounded-2xl mx-auto mb-4 flex items-center justify-center">
            <ZoomIn size={24} className="text-white/20" />
          </div>
          <p className="text-white/40 text-sm">Shared assets will appear here</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="flex-1 overflow-y-auto p-4">
        <div className="grid grid-cols-2 gap-3">
          {assets.map(asset => (
            <button
              key={asset.id}
              onClick={() => setLightbox(asset)}
              className="relative aspect-square bg-white/5 rounded-2xl overflow-hidden border border-white/10 active:scale-95 transition-transform"
            >
              <img
                src={asset.url}
                alt={asset.name}
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black/70 to-transparent p-2">
                <p className="text-white text-xs font-medium truncate">{asset.name}</p>
              </div>
            </button>
          ))}
        </div>
      </div>

      {lightbox && (
        <div
          className="fixed inset-0 bg-black/90 z-50 flex flex-col"
          onClick={() => setLightbox(null)}
        >
          <div className="flex items-center justify-between p-4">
            <p className="text-white font-medium text-sm">{lightbox.name}</p>
            <button className="text-white/60 p-1">
              <X size={20} />
            </button>
          </div>
          <div className="flex-1 flex items-center justify-center p-4" onClick={e => e.stopPropagation()}>
            <img
              src={lightbox.url}
              alt={lightbox.name}
              className="max-w-full max-h-full rounded-xl object-contain"
            />
          </div>
        </div>
      )}
    </>
  );
}
